import {
	API_GET_ALL_SPECIALTY,
	API_GET_ALL_SPECIALTY_SUCCESS,
	API_GET_ALL_SPECIALTY_FAIL,
} from '../actions/specialty';
import { createReducer } from '@reduxjs/toolkit';
import { ErrorAction, errorHandler } from 'utils/error';

const initialState = {
    loading: false,
	list: []
};

const specialties = createReducer(initialState, {
	/** GET ALL **/
	[API_GET_ALL_SPECIALTY]: (state, action) => {
		state.loading = true;
	},
	[API_GET_ALL_SPECIALTY_FAIL]: (state, action) => {
		errorHandler('Spécialité', ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_GET_ALL_SPECIALTY_SUCCESS]: (state, action) => {
		state.loading = false;
		state.list = action.payload.data;
	},

});

export default specialties;
